import React from 'react'
import Paragraph from '@/shared/v2/shared/components/Paragraph'

interface ImportFieldProps {
    label: string
    children: React.ReactNode
}

const ImportField = ({ label, children }: ImportFieldProps) => (
    <div className="grid grid-cols-1 gap-1">
        <Paragraph color="darkGrey" size={3}>
            {label}
        </Paragraph>
        {children}
    </div>
)

export default ImportField
